export default function AirPump(props: any) {
    return (
        <svg width="49" height="48" viewBox="0 0 49 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#clip0_3295_3844)">
                <circle cx="33.668" cy="25.5" r="10.5" stroke="white" strokeWidth="2.25" />
                <circle cx="33.668" cy="25.5" r="6" stroke="white" />
                <path
                    d="M33.668 15L6.25129 15.0004C5.65298 15.0005 5.16797 15.4855 5.16797 16.0838V20.1371C5.16797 20.6348 5.50716 21.0685 5.99025 21.1885L23.355 25.5"
                    stroke="white"
                    strokeWidth="2.25"
                />
                <path d="M9.88281 15.2012V21.9305" stroke="white" strokeWidth="2.25" />
                <path d="M33.6536 19.8398C33.4549 20.4028 33.2232 21.959 33.6536 23.5815" stroke="white" strokeWidth="0.8" />
                <path d="M33.4128 27.2666C33.6115 27.8295 33.8433 29.4795 33.4128 31.102" stroke="white" strokeWidth="0.8" />
                <path d="M39.293 25.3665C38.7301 25.1678 37.1738 24.936 35.5513 25.3665" stroke="white" strokeWidth="0.8" />
                <path d="M31.5391 25.1237C30.9762 25.3224 29.4199 25.5542 27.7974 25.1237" stroke="white" strokeWidth="0.8" />
                <path
                    d="M24.668 15.5298L26.2287 11.9643C26.6098 11.0937 27.5137 10.5731 28.458 10.6803L38.8288 11.8578C39.8413 11.9727 40.6368 12.7776 40.7399 13.7914L41.168 18"
                    stroke="white"
                    strokeWidth="2.25"
                />
                <circle cx="33.668" cy="25.5" r="2.25" stroke="white" strokeWidth="1.5" />
                <path
                    d="M41.5896 34.0245L42.5276 35.6492C42.7347 36.0079 42.6118 36.4666 42.2531 36.6737L39.655 38.1737C39.2963 38.3808 38.8376 38.2579 38.6305 37.8992L37.6925 36.2745L41.5896 34.0245Z"
                    stroke="white"
                    strokeWidth="1.5"
                />
                <path
                    d="M25.5081 34.0245L24.5701 35.6492C24.363 36.0079 24.4859 36.4666 24.8446 36.6737L27.4427 38.1737C27.8014 38.3808 28.2601 38.2579 28.4672 37.8992L29.4052 36.2745L25.5081 34.0245Z"
                    stroke="white"
                    strokeWidth="1.5"
                />
            </g>
            <defs>
                <clipPath id="clip0_3295_3844">
                    <rect width="48" height="48" fill="white" transform="translate(0.667969)" />
                </clipPath>
            </defs>
        </svg>
    );
}
